<script setup lang="ts">
  import { provide, watch } from 'vue'
  import { usePortDetail, portDetailKey } from '../../composables/usePortDetail'

  // Resolves a single tenant-configured local port by location code and
  // provides it to the detail modal subtree. The location code is a one-way
  // prop driven by the modal-host entry (URL-owned), so re-fetch whenever it
  // changes — including the first immediate run for a deep-linked open.
  const props = defineProps<{ locationCode?: string }>()

  const datasource = usePortDetail()
  provide(portDetailKey, datasource)

  watch(
    () => props.locationCode,
    (locationCode) => datasource.fetchPort(locationCode),
    { immediate: true }
  )

  defineExpose(datasource)
</script>

<template>
  <slot />
</template>
